import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../../store'

// Define a type for the slice state
interface ChangeState {
  value: string
}

// Define the initial state using that type
const initialState: ChangeState = {
  value: 'initial',
}

export const changeSlice = createSlice({
  name: 'change',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  // Reducers son las "funciones" que voy a tener
  reducers: {
    varChange: (state, action: PayloadAction<string>) => {
        state.value = action.payload
      },
  },
})

export const { varChange} = changeSlice.actions

export const selectChange = (state: RootState) => state.change.value

export default changeSlice.reducer

